<template>
  <CContainer fluid>
    <h3>Formulario de Producto</h3>
    <CForm class="mt-4">
      <CTabs>
        <CTab title="Básicos">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="sm-4">
                  <CSelect
                    label="Clase Producto: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.clase_Producto"
                    :options="productClasses"
                    :isValid="Boolean(product.clase_Producto)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Código:"
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.codigo"
                    :isValid="Boolean(product.codigo)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Barcode:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.barcode" />
                </CCol>
                <CCol col="sm-12">
                  <CInput label="Descripción:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.descripcion"
                    :isValid="Boolean(product.descripcion)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CSelect
                    label="Presentación: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.referencia"
                    :options="references"
                    :isValid="Boolean(product.referencia)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CSelect
                    label="Fabricante: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.fabricante"
                    :options="manufacturers"
                    :isValid="Boolean(product.fabricante)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CSelect
                    label="Marca: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.marca"
                    :options="brands"
                    :isValid="Boolean(product.marca)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CSelect
                    label="Categoría: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.ciiu"
                    :options="categories"
                    :isValid="Boolean(product.ciiu)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-4">
                  <CSelect
                    label="Sub Categoría: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.sub_Ciiu"
                    :options="subcategories"
                    @change="() => {}" />
                </CCol>
                <CCol col="sm-4">
                  <CSelect
                    label="Grupo: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.grupo_Producto"
                    :options="productGroups" />
                </CCol>
                <CCol col="sm-3">
                  <CSelect
                    label="Tarifa IVA: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.iva"
                    :options="vatRates"
                    :isValid="Boolean(product.iva)"
                    @change="() => validate()" />
                </CCol>
                <CCol col="sm-3" class="mt-4 pt-2">
                  <label class="text-muted font-weight-bold">IVA Incluido:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="ivaIncluidoStatus" 
                    @update:checked="value => {
                      product.iva_Incluido = value ? 'V' : 'F';
                    }" />
                  <span class="font-weight-bold">{{ product.iva_Incluido === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
                <CCol col="sm-3" class="mt-4 pt-2">
                  <label class="text-muted font-weight-bold">INC:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="incStatus" 
                    @update:checked="value => {
                      product.impuesto_Consumo = ''
                      product.activa_ImpConsumo = value ? 'V' : 'F'
                    }" />
                  <span class="font-weight-bold">{{ product.activa_ImpConsumo === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
                <CCol col="sm-3">
                  <CSelect
                    label="Tarifa INC: "
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.impuesto_Consumo"
                    :options="consumptionTaxes"
                    :class="product.activa_ImpConsumo === 'F' ? '' : 'disabled'"
                    :disabled="product.activa_ImpConsumo === 'F'" />
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>          
        </CTab>
        <CTab title="Extras">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol col="sm-12">
                  <CTextarea
                    label="Caracteristicas:"
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.caracteristicas" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Contenido:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.contenido" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Embalaje:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.embalaje" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Peso:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.peso" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Alto:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.medida_Alto" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Ancho:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.medida_Ancho" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Fondo:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.medida_Fondo" />
                </CCol>
                <CCol col="sm-12">
                  <CInput label="Descripción Auxiliar:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.descripcion_Aux" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Código Auxiliar:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.codigo_Aux" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Valor ImpConsumo:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.valor_ImpConsumo" />
                </CCol>
                <CCol col="sm-4">
                  <CInput label="Valor Referencia:" 
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.precio_Referecia" />
                </CCol>
                <CCol col="sm-3" class="mt-4">
                  <label class="text-muted font-weight-bold">ICUI:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="icuiStatus" 
                    @update:checked="(value) => {
                      product.activaICUI = value ? 'V' : 'F'
                    }" />
                  <span class="font-weight-bold">{{ product.activaICUI === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
                <CCol col="sm-3">
                  <CSelect
                    label="Tarifa ICUI:"
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.incId"
                    :options="[]" />
                </CCol>
                <CCol col="sm-3" class="mt-4">
                  <label class="text-muted font-weight-bold">IBUA:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="ibuaStatus" 
                    @update:checked="(value) => {
                      product.activaIBUA = value ? 'V' : 'F'
                    }" />
                  <span class="font-weight-bold">{{ product.activaIBUA === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
                <CCol col="sm-3">
                  <CSelect
                    label="Tarifa IBUA:"
                    addLabelClasses="text-muted font-weight-bold"
                    :value.sync="product.ibuaId"
                    :options="[]" />
                </CCol>
                <CCol col="sm-4" class="pt-2">
                  <label class="text-muted font-weight-bold">Producto Tercero:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="productoTerceroStatus" 
                    @update:checked="(value) => {
                      product.producto_Tercero = value ? 'V' : 'F'
                    }" />
                  <span class="font-weight-bold">{{ product.producto_Tercero === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
                <CCol col="sm-4" class="pt-2">
                  <label class="text-muted font-weight-bold">Precio Libre:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="precioLibreStatus" 
                    @update:checked="(value) => {
                      product.precio_Libre = value ? 'V' : 'F'
                    }" />
                  <span class="font-weight-bold">{{ product.precio_Libre === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
                <CCol col="sm-4" class="pt-2">
                  <label class="text-muted font-weight-bold">Estado:</label>
                  <CSwitch 
                    color="dark" 
                    shape="pill" 
                    variant="opposite" 
                    class="align-middle mx-2"
                    :checked.sync="inactivoStatus" 
                    @update:checked="(value) => {
                      product.inactivo = value ? 'V' : 'F'
                    }" />
                  <span class="font-weight-bold">{{ product.inactivo === 'V' ? 'Activo' : 'Inactivo' }}</span>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CTab>
      </CTabs>
      <CRow>
        <CCol col="sm-12">
          <div class="d-flex justify-content-center">
            <CButton 
              color="success" 
              class="mr-2" 
              :class="isValidForm ? '' : 'disabled'"
              :disabled="!isValidForm" 
              @click="saveProduct()">
              <CIcon name="cil-check-circle" class="mr-2" />
              <span class="align-middle">Guardar</span>
            </CButton>
            <CButton 
              color="danger" 
              variant="outline" 
              class="mr-2"
              :to="rootPath">
              <CIcon name="cil-x-circle" class="mr-2" />
              <span class="align-middle">Cancelar</span>
            </CButton>
          </div>          
        </CCol>
      </CRow>      
      
      <LoadingCover spinner="dotsbar" v-show="loading" />
    </CForm>
  </CContainer>
</template>
<script>
  import { ref } from "vue";

  import CONSTANTS from "@/constants";
  import { 
    dataListReferencias, 
    dataListFabricantes, 
    dataListMarcas, 
    dataListCiius, 
    dataListSubCiius, 
    dataListGruposProductos,
    dataListIvas,
    dataListImpuestosConsumo,
  } from "@/apiDataList";
  import { crudProductos } from "@/apis/products";
  // import { obtenerProducto } from "@/api";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  export default ({
    name: "ProductForm",
    data() {
      return {
        CONSTANTS,
        loading: false,
        isCreate: false,
        isValidForm: false,
        product: {
          codigo: "",
          barcode: "",
          descripcion: "",
          codigo_Aux: "",
          descripcion_Aux: "",
          referencia: "",
          fabricante: "",
          ciiu: "",
          sub_Ciiu: "",
          iva: "",
          iva_Incluido: "F",
          marca: "",
          grupo_Producto: "",
          unidad_Medida: "",
          activa_ImpConsumo: "F",
          impuesto_Consumo: "",
          valor_ImpConsumo: 0,
          clase_Producto: "T",
          inactivo: "F",
          caracteristicas: "",
          embalaje: "",
          peso: 0,
          contenido: "",
          medida_Alto: 0,
          medida_Ancho: 0,
          medida_Fondo: 0,
          precio_Referecia: 0,
          producto_Tercero: "",
          precio_Libre: "",
          incId: "",
          activaICUI: "",
          icuiId: "",
          activaIBUA: "",
          ibuaId: "",
        },
        emptyItem: {
          value: "",
          label: "Seleccionar"
        },
        productClasses: [
          {
            value: "T",
            label: "Terminado"
          },
          {
            value: "S",
            label: "Servicio"
          },
          {
            value: "I",
            label: "Insumo"
          }
        ],
        references: [],
        manufacturers: [],
        brands: [],
        gruops: [],
        categories: [],
        subcategories: [],
        productGroups: [],
        vatRates: [],
        consumptionTaxes: [],
        tarifasIcui: [],
        tarifasIbua: [],
        productId: "",
        inactivoStatus: false,
        ivaIncluidoStatus: false,
        incStatus: false,
        icuiStatus: false,
        ibuaStatus:false,
        productoTerceroStatus: false,
        precioLibreStatus:false,
        rentContractIndex: ""
      }
    },
    components: {
      LoadingCover
    },
    methods: {
      async getProduct(productId) {
        this.loading = true;

        try {
          const { response } = await crudProductos(this, "read", productId);
          this.product = {
            clase_Producto: response.clase_Producto,
            codigo: response.codigo,
            barcode: response.barcode,
            descripcion: response.descripcion,
            referencia: response.referencia,
            fabricante: response.fabricante,
            marca: response.marca,
            ciiu: response.ciiu,
            sub_Ciiu: response.sub_Ciiu,
            grupo_Producto: response.grupo_Producto,
            iva: response.iva,
            iva_Incluido: response.iva_Incluido,
            activa_ImpConsumo: response.activa_ImpConsumo,
            incId: response.incId,
            impuesto_Consumo: response.impuesto_Consumo,
            caracteristicas: response.caracteristicas,
            contenido: response.contenido,
            embalaje: response.embalaje,
            peso: response.peso,
            medida_Alto: response.medida_Alto,
            medida_Ancho: response.medida_Ancho,
            medida_Fondo: response.medida_Fondo,
            descripcion_Aux: response.descripcion_Aux,
            codigo_Aux: response.codigo_Aux,
            valor_ImpConsumo: response.valor_ImpConsumo,
            precio_Referecia: response.precio_Referecia,
            activaICUI: response.activaICUI,
            icuiId: response.icuiId,
            activaIBUA:response.activaIBUA,
            ibuaId:response.ibuaId,
            producto_Tercero: response.producto_Tercero,
            precio_Libre: response.precio_Libre,
            inactivo: response.inactivo,

            unidad_Medida: response.unidad_Medida
          }
          this.ivaIncluidoStatus = response.iva_Incluido === "V" ? true : false;
          this.incStatus = response.activa_ImpConsumo === "V" ? true : false;
          this.icuiStatus = response.activaICUI === "V" ? true : false;
          this.ibuaStatus = response.activaIBUA === "V" ? true : false;
          this.productoTerceroStatus = response.producto_Tercero === "V" ? true : false;
          this.precioLibreStatus = response.precio_Libre === "V" ? true : false;
          this.inactivoStatus = response.inactivo === "V" ? true : false;
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: CONSTANTS.messages.notDoneLoad,
            show: 5
          });
          this.$router.push({ path: this.rootPath });
        } finally {
          this.loading = false;
        }
      },
      async saveProduct() {
        this.loading = true

        try {
          const processData = {}

          Object.keys(this.product).forEach(key => {
            if (this.isCreate) {
              this.product[key] ? processData[key] = this.product[key] : undefined;
            } else {
              processData[key] = this.product[key] ? this.product[key] : null;
            }
          });

          if (this.isCreate) {
            await crudProductos(this, "create", null, processData);
          } else {
            await crudProductos(this, "update", this.productId, processData);
          }

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });

          this.$router.push({ path: this.rootPath });
        } catch (error) {
          console.log(error);
          
          this.catchError(this.isCreate ? CONSTANTS.messages.notDoneAdd : CONSTANTS.messages.notDoneEdit)
        } finally {
          this.loading = false
        }
      },
      async getListReferences() {
        try {
          const response = await dataListReferencias(this)

          this.references = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_Referencia,
                label: item.referencia
              }
            })
          ] 
        } catch {
          console.log()
        }
      },
      async getListManufacturers() {
        try {
          const response = await dataListFabricantes(this)

          this.manufacturers = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_Fabricante,
                label: item.fabricante
              }
            })
          ] 
        } catch {
          console.log()
        }
      },
      async getListBrands() {
        try {
          const response = await dataListMarcas(this)

          this.brands = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_Marca,
                label: item.marca
              }
            })
          ]
        } catch {
          console.log()
        }
      },
      async getListCategories() {
        try {
          const response = await dataListCiius(this);

          this.categories = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_Ciiu,
                label: item.descripcion
              }
            })
          ]
        } catch {
          console.log();
        }
      },
      async getListSubCategories() {
        try {
          const response = await dataListSubCiius(this)

          this.subcategories = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_SubCiiu,
                label: item.descripcion
              }
            })
          ] 
        } catch {
          console.log()
        }
      },
      async getListProductGroups() {
        try {
          const response = await dataListGruposProductos(this)

          this.productGroups = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_GrupoProducto,
                label: item.grupo_Producto
              }
            })
          ]
        } catch {
          console.log()
        }
      },
      async getListVATs() {
        try {
          const response = await dataListIvas(this)

          this.vatRates = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_Iva,
                label: `${item.factor_Iva} - ${item.tipo_Iva === "A" ? "Exento" : item.tipo_Iva === "B" ? "Excluido" : "Gravado"}`
              }
            })
          ]
        } catch {
          console.log()
        }
      },
      async getListConsumptionTaxes() {
        try {
          const response = await dataListImpuestosConsumo(this);

          console.log(response);
          

          this.consumptionTaxes = [
            this.emptyItem,
            ...response.map(item => {
              return {
                value: item.id_ImpConsumo,
                label: `${item.codigo_ImpConsumo} - ${item.tipo_Cobro === "V" ? item.valor_ImpConsumo : item.factor_ImpConsumo}`
              }
            })
          ]
        } catch {
          console.log()
        }
      },
      validate() {
        const requiredFields = [
          "codigo", 
          "descripcion",
          "referencia",
          "fabricante",
          "ciiu",
          "iva",
          "marca",
          "clase_Producto"
        ];
        this.isValidForm = requiredFields.reduce((acc, key) => {
          return acc && (this.product[key].length > 0);
        }, true);
      },
      catchError(message) {
        this.$store.commit('setAlert', {
          color: "danger",
          message: message,
          show: 5
        })
        this.loading = false
      }
    },
    setup() {
      const rootPath = ref("");

      return {
        rootPath
      }
    },
    async mounted() {
      this.productId = this.$router.currentRoute.params.id;
      this.rootPath = this.$router.currentRoute.fullPath.replace(`/${this.productId}`, "");

      const splittedPath = this.rootPath.split("/");
      const action = splittedPath[splittedPath.length - 1];

      this.rootPath = this.rootPath.replace(`/${action}`, "");
      this.isCreate = action === "agregar";

      this.getListReferences();
      this.getListManufacturers();
      this.getListBrands();
      this.getListCategories();
      this.getListSubCategories();
      // this.getListProductGroups();
      this.getListVATs();
      this.getListConsumptionTaxes();

      if (!this.isCreate) {
        await this.getProduct(this.productId);
        this.validate();
      }
    }
  })
</script>
